export default __webpack_public_path__ + "static/media/ps5-mobile.2f812dd3.png";